export enum FluidSlugType {
  ELECTRICITY = 'enedissgegrandlyon',
  WATER = 'eglgrandlyon',
  GAS = 'grdfgrandlyon',
}
